import React, { useContext, useEffect, useState } from "react";
import "../../Tabels/Tabels.css";
import plus from "../../../Components/assets/icons/a1.png";
import search1 from "../../../Components/assets/icons/search.png";
import pen from "../../../Components/assets/icons/pen.png";
import Table from "react-bootstrap/Table";
import { Button } from "react-bootstrap";
import toast, { Toaster } from "react-hot-toast";
import Header from "../../Header/Header";
import { Context } from "../../../utils/context";
import { IDS } from "../../../utils/common";
import AddOffCanvance from "./Add";
import ModalDelete from "../../common/ModelDelete";
import { DeletButton } from "../../common/Button";
import Pagination_Holder from "../../common/Pagination_Holder/Pagination_Holder";
import Loader from "../../common/Loader/Loader";

// Admin panels served over plain http have no Clipboard API
const copyToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
  } catch {
    const input = document.createElement("textarea");
    input.value = text;
    document.body.appendChild(input);
    input.select();
    document.execCommand("copy");
    input.remove();
  }
  toast.success("Link copied");
};

const Tables = () => {
  const { getData, editStatusData, deleteData, ErrorNotify, Per_Page_Dropdown, isAllow } =
    useContext(Context);

  const [data, setData] = useState([]);
  const [perPage, setperPage] = useState(5);
  const [search, setSearch] = useState("");
  const [reset, setReset] = useState();
  const [option, setOption] = useState();
  const [totalPages, settotalPages] = useState();
  const [onPageChange, setonPageChange] = useState(1);
  const [loading, setLoading] = useState(false);
  const [changeStatus, setChangeStatus] = useState();
  // false = closed, true = add, number = edit that id
  const [modal, setModal] = useState(false);

  const getDataAll = async () => {
    setLoading(true);
    const response = await getData(
      `/admin/offer-advertisement?page=${onPageChange}&per_page=${perPage}&term=${encodeURIComponent(search)}`,
    );
    setData(response);
    setLoading(false);
    settotalPages(response?.data?.total_pages);
    setOption(await Per_Page_Dropdown(response?.data?.total));
  };

  useEffect(() => {
    getDataAll();
  }, [changeStatus, perPage, reset, modal, onPageChange]);

  const ChangeStatus = async (id) => {
    const response = await editStatusData(`/admin/offer-advertisement/${id}`);
    setChangeStatus(response);
  };

  // Delete module
  const [recordToDelete, setRecordToDelete] = useState(null);

  const handleDeleteRecord = async () => {
    const response = await deleteData(`/admin/offer-advertisement/${recordToDelete.id}`);
    ErrorNotify(recordToDelete.name);
    setRecordToDelete(null);
    setChangeStatus(response);
  };

  const rows = data?.data?.data || [];
  const total = data?.data?.total || 0;

  return (
    <>
      <div className="main-advancedashboard">
        <Header title={"Offer Links"} link={"/admin/offer-advertisement"} />
        <section className="AdvanceDashboard">
          <div className="col-lg-12 p-0">
            <div className="row MainRowsec me-0 ms-0">
              <section className="Tabels tab-radio tab-radio mt-3">
                <div className="row">
                  <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-4 col-sm-6 mb-2">
                    <div className="add me-3">
                      {isAllow?.includes(IDS.Coupon.Add) && (
                        <button type="button" className="btn btn-add pe-3" onClick={() => setModal(true)}>
                          <img src={plus} className="plus me-2 ms-0" alt="" />
                          Add Offer Link
                        </button>
                      )}
                    </div>
                  </div>

                  <div className="border-line mt-3"></div>
                  <div className="row mt-4">
                    <div className="col-12">
                      <div className="d-flex align-items-center mb-3">
                        <div className="show me-2">
                          <p className="show m-0">Show</p>
                        </div>
                        <div className="number me-2">
                          <select
                            className="form-select form-select-sm"
                            aria-label=".form-select-sm example"
                            onChange={(e) => {
                              setonPageChange(1);
                              setperPage(e.target.value);
                            }}
                          >
                            {option?.map((option) => (
                              <option key={option} value={option}>
                                {option}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="entries">
                          <p className="show m-0">entries</p>
                        </div>
                        <div className="sowing ms-3 me-2">
                          <p className="show m-0">{`Showing ${total ? (onPageChange - 1) * perPage + 1 : 0} to ${Math.min(
                            onPageChange * perPage,
                            total,
                          )} of ${total} entries`}</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="row align-items-end">
                        <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-4 col-sm-6 mb-2">
                          <div className="num">
                            <input
                              type="text"
                              className="form-control"
                              value={search}
                              placeholder="Search slug, source or coupon code"
                              onChange={(e) => setSearch(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-4 col-sm-6 mb-2 d-flex gap-3 align-items-end">
                          <div className="Search me-2">
                            <Button
                              type="button"
                              onClick={() => {
                                setonPageChange(1);
                                getDataAll();
                              }}
                              className="btn btn-search"
                            >
                              <img src={search1} className="search" alt="" />
                            </Button>
                          </div>
                          <div className="Search-1">
                            <button
                              type="button"
                              onClick={() => {
                                setSearch("");
                                setReset(!reset);
                              }}
                              className="btn btn-reset"
                            >
                              Reset
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="border-line mt-3"></div>
                <div className="row mt-3">
                  <div className="data table-responsive">
                    <Table striped bordered hover responsive center>
                      <thead>
                        <tr>
                          <th className="sr">Sr. No.</th>
                          <th className="tax-name">Coupon</th>
                          <th className="tax-name">Source</th>
                          <th className="tax-name">Destination</th>
                          <th className="tax-name">Share Link</th>
                          <th className="tax-name">Orders</th>
                          <th className="tax-name">Status</th>
                          <th className="active" style={{ width: "50px" }}>
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          <tr>
                            <td colSpan={8}>
                              <Loader type="dots" />
                            </td>
                          </tr>
                        ) : (
                          rows.map((d, index) => (
                            <tr key={d.id}>
                              <td>{(onPageChange - 1) * perPage + index + 1}.</td>
                              <td>
                                {d?.Coupon?.code}
                                {!d?.Coupon?.status && (
                                  <div className="text-danger small">Coupon inactive</div>
                                )}
                              </td>
                              <td>{d?.source}</td>
                              <td style={{ wordBreak: "break-all" }}>{d?.url}</td>
                              <td style={{ wordBreak: "break-all" }}>
                                <a href={d?.share_url} target="_blank" rel="noreferrer">
                                  {d?.share_url}
                                </a>
                                <div>
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-outline-success mt-1"
                                    onClick={() => copyToClipboard(d?.share_url)}
                                  >
                                    Copy
                                  </button>
                                </div>
                              </td>
                              <td>{d?.orders_count}</td>
                              <td>
                                <div className="form-check form-switch">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    role="switch"
                                    checked={d.status}
                                    disabled={!isAllow?.includes(IDS.Coupon.Edit)}
                                    onChange={() => ChangeStatus(d.id)}
                                    id={`flexSwitchCheckDefault${d?.id}`}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor={`flexSwitchCheckDefault${d?.id}`}
                                  >
                                    {d.status ? "Active" : "Inactive"}
                                  </label>
                                </div>
                              </td>
                              <td>
                                <div className="d-flex">
                                  {isAllow?.includes(IDS.Coupon.Edit) && (
                                    <Button className="action-btn active" onClick={() => setModal(d.id)}>
                                      <img src={pen} className="pen" alt="" />
                                    </Button>
                                  )}
                                  {isAllow?.includes(IDS.Coupon.Delete) && (
                                    <DeletButton
                                      showDeleteRecord={(id, name) => setRecordToDelete({ id, name })}
                                      id={d?.id}
                                      name={d?.slug}
                                    />
                                  )}
                                </div>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </Table>
                    {rows.length > 0 ? (
                      <Pagination_Holder
                        onPageChange={onPageChange}
                        totalPages={totalPages}
                        handlePageChange={setonPageChange}
                      />
                    ) : (
                      <p className="no-datashow">Sorry, No Data Found</p>
                    )}
                  </div>
                </div>
              </section>
            </div>
          </div>
        </section>
      </div>

      {modal !== false && (
        <AddOffCanvance
          show
          id={modal === true ? null : modal}
          handleClose={() => setModal(false)}
        />
      )}

      <ModalDelete
        show={!!recordToDelete}
        handleDeleteRecord={handleDeleteRecord}
        handleDeleteCancel={() => setRecordToDelete(null)}
      />
      <Toaster position="top-right" />
    </>
  );
};

export default Tables;
